import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { instanceToPlain } from 'class-transformer';
import { Observable } from 'rxjs';


/**
 * Intercepts all API requests and makes sure that all potential class instances (from class-transformer) are transformed back to
 * plain JSON objects before sending them to the HTTP backend.
 */
@Injectable()
export class SerializerInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!(request.body instanceof FormData) && request.body !== null && request.body !== undefined) {
      // Make sure we don't send class instances to the backend
      request = request.clone({
        body: instanceToPlain(request.body)
      });
    }

    return next.handle(request);
  }
}
